import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { OptionSelection } from '@/components';
import Space from '@/components/layout/Space';
import { TransactionPeriod } from '@/model/wallets/types';
import { Func } from '@/utils/ts';

// const BankLink = styled(ButtonLink)`
//   ${({ theme }: { theme: Theme }): string => `
//     align-items: center;
//     color: initial;
//     text-align: initial;
//     text-decoration: none !important;
//     outline: none !important;
//
//     > span {
//       padding-bottom: ${theme.spacing()}px;
//       padding-top: ${theme.spacing()}px;
//     }
//
//     &:hover > span {
//       background-color: ${theme.colors.light};
//     }
//
//     &:focus > span {
//       background-color: ${theme.colors.light};
//     }`}
// `;

interface TransactionFilterOptionSelectionProps {
  'data-test'?: string;
  value: TransactionPeriod;
  isSelected?: boolean;
  onSelect: Func<[TransactionPeriod]>;
}

const TransactionFilterOptionSelection: React.FC<TransactionFilterOptionSelectionProps> = ({
  value,
  onSelect,
  isSelected,
  'data-test': dataTest,
}) => {
  const select = useCallback(() => onSelect(value), [onSelect, value]);
  return (
    <Space direction="vertical" size={2} style={{ overflow: 'inherit' }}>
      <OptionSelection
        data-test={dataTest}
        title={<FormattedMessage id={`demo.pages.transactions.filter.select.items.${value}`} />}
        onSelect={select}
        disabled={isSelected}
      />
    </Space>
  );
};

export default React.memo(TransactionFilterOptionSelection);
